import { ListSubheader, MenuItem, Select } from "@mui/material";
import EAEvolutionLineChart from "components/common/charts/EAEvolutionLineChart";
import EADialog from "components/common/EADialog";
import i18next from "i18next";
import { useState } from "react";
import { SecurityRatingControlScores, SecurityRatingPerformanceScores } from "services/common/SecurityRatingUtils";
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';


const SecurityRatingHistoryModal = ({ isOpen = false, historyData, onClose = () => { } }) => {
  const { classes } = useStyles();
  const [selectedScore, setSelectedScore] = useState("global_score");

  return (
    <EADialog
      isOpen={isOpen}
      title={i18next.t('ecovadis.scoreEvolution')}
      hasActions={false}
      onClose={onClose}
      maxWidth="md"
    >
      <div className={classes.graphEvolutionDialog}>

        <Select
          id="security-rating-score-choice"
          onChange={(event) => setSelectedScore(event.target.value)}
          value={selectedScore}
          style={{ width: "100%", backgroundColor: '#FFF' }}
          inputProps={{ className: classes.historyMenuItem }}
        >
          <MenuItem className={classes.historyMenuItem} key="global_score" value="global_score">
            {i18next.t("securityRating.scores.global_score")}
          </MenuItem>
          <ListSubheader className={classes.historyListSubheader}>{i18next.t("securityRating.controlMeasures")}</ListSubheader>
          {Object.values(SecurityRatingControlScores)?.map((score) => (
            <MenuItem key={score} value={score} className={classes.historyMenuItem}>
              {i18next.t(`securityRating.scores.${score}`)}
            </MenuItem>
          ))}
          <ListSubheader className={classes.historyListSubheader}>{i18next.t("securityRating.performanceMeasures")}</ListSubheader>
          {Object.values(SecurityRatingPerformanceScores)?.map((score) => (
            <MenuItem key={score} value={score} className={classes.historyMenuItem}>
              {i18next.t(`securityRating.scores.${score}`)}
            </MenuItem>
          ))}
        </Select>

        <div className={classes.graphEvolutionContent}>
          <EAEvolutionLineChart
            id="security-rating-history-evolution-chart"
            data={historyData?.[selectedScore]}
            min={0}
            max={1000}
          />
        </div>
      </div>
    </EADialog>
  )
};

export default SecurityRatingHistoryModal;